import React, { useEffect, useState } from 'react';
import { Card, CardBody, Modal, ModalHeader, ModalBody, Row, Col } from 'reactstrap';
import { getPendingTasks, getOverduetasks } from 'http/UAM/userDashboardWidget.helper';
import ReactApexChart from 'react-apexcharts';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './index.css';
import NoDataChart from 'pages/EntityMoreInformation/NoDataComponent';

const PendingTasks = () => {
  const [timeLine, setTimeLine] = useState();
  const [taskData, setTaskData] = useState([]);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [showTask, setTask] = useState(false);
  const today = new Date();
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(null);
  const displayDateFormat = "dd-MM-yyyy";

  const handleFilterChange = (e) => {
    setTimeLine(e.target.value);
    setStartDate(today);
    setEndDate(null);
  };

  useEffect(() => {
    fetchData();
  }, [startDate, endDate, timeLine]);

  const fetchData = async () => {
    try {
      const response = await getPendingTasks({ startDate, endDate, timeLine });
      if (response.status) {
        setTaskData(response.data);
        setTask(true)
      } else {
        setTaskData([]);
        setTask(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setTaskData([]);
    }
  };

  const handleEndDateChange = (date) => {
    let utc = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
    setEndDate(utc);
    setTimeLine("");
    toggleCalendar();
  };

  const toggleCalendar = () => {
    setCalendarOpen(!calendarOpen);
  };
  const xAxisData = taskData?.map((entity) => `${entity.first_name} ${entity.last_name? entity.last_name : ""}`) || [];
  while (xAxisData.length < 6) {
    xAxisData.push(" ");
  }

  const options = {
    toolbar: {
      show: true,
      tools: {
        download: false,
      },
    },
    chart: {
      type: "bar",
      height: 500,
      width: taskData.length > 6 ? taskData.length * 50 : 300,
      toolbar: {
        show: true,
        tools: {
          download: false,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        endingShape: "flat",
        barHeight: "100%",
        barWidth: "25%",
        columnWidth: "50%",
        borderRadius: 0,
        dataLabels: {
          position: "center",
        },
      },
    },
    colors: [
      function ({ dataPointIndex }) {
        const colors = ["#00c5dc", "#f46a6a", "#34c38f", "#3f9ae5", "#f1b44c", "#0174BE"];
        return colors[dataPointIndex % colors.length];
      },
    ],
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    xaxis: {
      title: {
        text: "Users",
      },
      labels: {
        show: true,
        trim: true,
        rotate: 0,
        rotateAlways: false,
        hideOverlappingLabels: false,
      },
      categories: xAxisData,
    },
    yaxis: {
      title: {
        text: "Tasks",
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " Tasks";
        },
      },
    },
  };

  const series = [
    {
      name: "",
      data: taskData?.map((entity) => parseInt(entity.count)) || [],
    },
  ];

  return (
    <Card>
      <CardBody>
        <Row className="d-flex mb-2 custom-border">
          <Col lg='6' sm='12'>
            <h4 className="card-title mb-2 custom-title">Pending tasks by user</h4>
          </Col>
          <Col className="mb-2 custom-select-wrapper" lg='6' sm='12'>
            <select
              className="form-select"
              id="filterOptions"
              value={timeLine}
              onChange={handleFilterChange}
              style={{ width: '80%' }}
            >
              <option value="">Select</option>
              <option value="current_month">Current Month</option>
              <option value="today">Today</option>
              <option value="next_7_days">Next 7 Days</option>
            </select>
            <i
              className="bx bx-calendar-event me-1 custom-calendar-icon"
              onClick={toggleCalendar}
            ></i>
          </Col>
        </Row>
        {showTask ? (
          <div style={{ width: '100%', maxHeight: '407px' }} className='vertical-scroll'>
            <style>
            {`
              ::-webkit-scrollbar {
                width: 6px;
              }
              ::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 3px;
              }
              ::-webkit-scrollbar-thumb {
                background: #888;
                border-radius: 3px;
              }
              ::-webkit-scrollbar-thumb:hover {
                background: #555;
              }
              div::-webkit-scrollbar {
                width: 6px;
              }
              div::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 3px;
              }
              div::-webkit-scrollbar-thumb {
                background: #888;
                border-radius: 3px;
              }
              div::-webkit-scrollbar-thumb:hover {
                background: #555;
              }
            `}
          </style>
            <ReactApexChart
              options={options}
              series={series}
              type="bar"
              height={365}
              // width={taskData.length > 6 ? taskData.length * 50 : 300}
            />
          </div>
        ) : (
          <NoDataChart title='No Information Found' subtitle="No pending tasks are available for any user" />
        )}
        <Modal
          className="position-absolute top-50 start-50 translate-middle"
          isOpen={calendarOpen}
          toggle={toggleCalendar}
        >
          <ModalHeader toggle={toggleCalendar}>Select Date Range</ModalHeader>
          <ModalBody>
            <div className="d-flex flex-column align-items-center">
              <label htmlFor="startDatePicker" className="form-label">Start Date</label>
              <DatePicker
                selected={startDate}
                dateFormat={displayDateFormat}
                className="form-control mb-3 text-center"
                disabled={true}
              />
              <label htmlFor="endDatePicker" className="form-label">End Date</label>
              <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                dateFormat={displayDateFormat}
                placeholderText={displayDateFormat.toUpperCase()}
                className="form-control mb-3 text-center"
              />
            </div>
          </ModalBody>
        </Modal>
       </CardBody>
    </Card>
  );
};

const OverdueTasks = () => {
  const [timeLine, setTimeLine] = useState();
  const [taskData, setTaskData] = useState([]);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [showTask, setTaskShow] = useState(false);
  const today = new Date();
  // today.setDate(today.getDate() - 1);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(today);
  const displayDateFormat = "dd-MM-yyyy";

  const handleFilterChange = (e) => {
    setTimeLine(e.target.value);
    setStartDate(null);
    setEndDate(today);
  };

  useEffect(() => {
    fetchData();
  }, [startDate, endDate, timeLine]);

  const fetchData = async () => {
    try {
      const response = await getOverduetasks({ startDate, endDate, timeLine });
      if (response.status) {
        setTaskData(response.data);
        setTaskShow(true);
      } else {
        setTaskData([]);
        setTaskShow(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setTaskData([]);
    }
  };

  const handleStartDateChange = (date) => {
    let utc = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
    setStartDate(utc);
    setTimeLine("");
    toggleCalendar();
  };

  const toggleCalendar = () => {
    setCalendarOpen(!calendarOpen);
  };

  const xAxisData = taskData?.map((entity) => `${entity.first_name} ${entity.last_name? entity.last_name : ""}`) || [];
  while (xAxisData.length < 6) {
    xAxisData.push(" ");
  }

  const options = {
    toolbar: {
      show: true,
      tools: {
        download: false,
      },
    },
    chart: {
      type: "bar",
      height: 500,
      width: taskData.length > 6 ? taskData.length * 50 : 300,
      toolbar: {
        show: true,
        tools: {
          download: false,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        endingShape: "flat",
        barHeight: "100%",
        barWidth: "25%",
        columnWidth: "50%",
        borderRadius: 0,
        dataLabels: {
          position: "center",
        },
      },
    },
    colors: [
      function ({ dataPointIndex }) {
        const colors = ["#00c5dc", "#f46a6a", "#34c38f", "#3f9ae5", "#f1b44c", "#0174BE"];
        return colors[dataPointIndex % colors.length];
      },
    ],
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    xaxis: {
      title: {
        text: "Users",
      },
      labels: {
        show: true,
        trim: true,
        rotate: 0,
        rotateAlways: false,
        hideOverlappingLabels: false,
      },
      categories: xAxisData,
    },
    yaxis: {
      title: {
        text: "Tasks",
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " Tasks";
        },
      },
    },
  }

  const series = [
    {
      name: "",
      data: taskData?.map((entity) => parseInt(entity.count)) || [],
    },
  ];

  return (
    <Card>
      <CardBody>
        <Row className="mb-2 custom-container">
          <Col lg='6' sm='12' md='6'>
            <h4 className="card-title mb-2 custom-title">Overdue tasks by user</h4>
          </Col>
          {/* {showTask ? ( */}
          <Col className="mb-2 custom-select-wrapper" lg='6' sm='12' md='6'>
            <select
              className="form-select"
              id="filterOptions"
              value={timeLine}
              onChange={handleFilterChange}
              style={{ width: '80%' }}
            >
              <option value="">Select</option>
              <option value="current_month">Current Month</option>
              <option value="last_month">Last Month</option>
              <option value="last_7_days">Last 7 Days</option>
            </select>
            <i
              className="bx bx-calendar-event me-1 custom-calendar-icon"
              onClick={toggleCalendar}
            ></i>
          </Col>
          {/* ) :null} */}
        </Row>
        {showTask ? (
          <div style={{ width: '100%'}} className='vertical-scroll'>
            <style>
            {`
              ::-webkit-scrollbar {
                width: 6px;
              }
              ::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 3px;
              }
              ::-webkit-scrollbar-thumb {
                background: #888;
                border-radius: 3px;
              }
              ::-webkit-scrollbar-thumb:hover {
                background: #555;
              }
              div::-webkit-scrollbar {
                width: 6px;
              }
              div::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 3px;
              }
              div::-webkit-scrollbar-thumb {
                background: #888;
                border-radius: 3px;
              }
              div::-webkit-scrollbar-thumb:hover {
                background: #555;
              }
            `}
          </style>
            <ReactApexChart
              options={options}
              series={series}
              type="bar"
              height={365}
              // width={taskData.length > 6 ? taskData.length * 50 : 300}
            />
          </div>
        ) : (
          <NoDataChart title='No Information Found' subtitle="No overdue tasks are available for any user" />
        )}
        <Modal
          className="position-absolute top-50 start-50 translate-middle"
          isOpen={calendarOpen}
          toggle={toggleCalendar}
        >
          <ModalHeader toggle={toggleCalendar}>Select Date Range</ModalHeader>
          <ModalBody>
            <div className="d-flex flex-column align-items-center">
              <label htmlFor="startDatePicker" className="form-label">Start Date</label>
              <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                maxDate={today}
                placeholderText={displayDateFormat.toUpperCase()}
                dateFormat={displayDateFormat}
                className="form-control mb-3 text-center"
              />
              <label htmlFor="endDatePicker" className="form-label">End Date</label>
              <DatePicker
                selected={endDate}
                // onChange={handleEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                maxDate={today}
                disabled={true}
                placeholderText={displayDateFormat.toUpperCase()}
                dateFormat={displayDateFormat}
                className="form-control text-center"
              />
            </div>
          </ModalBody>
        </Modal>
      </CardBody>
    </Card>
  );
};

export { PendingTasks, OverdueTasks };
